module.exports = __webpack_public_path__ + "img/c9h-create.0f822791.png";